import { FormControlProps } from '@lsy-netline/netline-ui/FormControl';
import clsx from 'clsx';
import { forwardRef, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { FormControl, FormControlLabel, FormLabel, MenuItem, Radio, RadioGroup, styled } from 'netline-ui';
import services from 'services';
import { CloseableComponentProps, Timezone } from 'types';

import styles, { darkModeSelectorClasses } from './DarkModeSelector.styles';

const TimezoneSelectorRoot = styled(FormControl, { name: darkModeSelectorClasses.$name })(styles);

type TimezoneSelectorProps = CloseableComponentProps & FormControlProps;

const DISPLAY_TIMEZONES = [Timezone.UTC_WITH_LOCAL, Timezone.UTC, Timezone.LOCAL];

const TimezoneSelector = forwardRef<HTMLDivElement, TimezoneSelectorProps>(
  ({ className, onMenuClose, ...props }, ref) => {
    const { t } = useTranslation();
    const [selectedTimezone, setSelectedTimezone] = useState(services.appFrame.timezone.getTimezone());

    useEffect(() => {
      return services.appFrame.timezone.onTimezoneChange((newTimezone) => {
        setSelectedTimezone(newTimezone);
      });
    }, []);

    const handleSelectItem = useCallback((event) => {
      const selected = event.currentTarget.dataset.value as Timezone;
      setSelectedTimezone(selected);
      services.appFrame.timezone.setTimezone(selected);
    }, []);

    return (
      <TimezoneSelectorRoot ref={ref} className={clsx(className, darkModeSelectorClasses.root)} {...props}>
        <FormLabel className={darkModeSelectorClasses.label}>{t('timezone.title')}</FormLabel>
        <RadioGroup data-testid="DarkModeSelector-radioGroup" value={selectedTimezone}>
          {DISPLAY_TIMEZONES.map((item) => (
            <MenuItem key={item} className={darkModeSelectorClasses.item} onChange={handleSelectItem} data-value={item}>
              <FormControlLabel
                value={item}
                control={<Radio size="small" data-testid={`Timezone-${item}Radio`} />}
                label={t(`timezone.${item.toString().toLowerCase()}`)}
              />
            </MenuItem>
          ))}
        </RadioGroup>
      </TimezoneSelectorRoot>
    );
  },
);

export default TimezoneSelector;
